import { makeStyles, createStyles } from "@material-ui/core/styles";


export default makeStyles(() =>
    createStyles({
        root: {
            marginBottom: "1em",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
        },
    }),
);
